import React from 'react'

import { useAppSelector } from 'redux/hooks'

import styles from './numberOfResults.module.scss'

type Props = {}

const NumberOfResults = ({}: Props) => {
  const numberOfResults = useAppSelector(state => state.collectionV2.numberOfResults)

  return (
    <div className={styles.resultQuantity}>
      Total result{numberOfResults !== 1 ? 's' : ''}: {numberOfResults}
    </div>
  )
}

export default NumberOfResults
